import { Component, Input, OnInit, ChangeDetectorRef, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss']
})

export class SidePanelComponent implements OnInit, AfterViewInit {

  @Input() template: any;
  @Input() show?: boolean;

  constructor(private cdr: ChangeDetectorRef) { }


  ngOnInit(): void {
    var t = <HTMLInputElement>document.getElementById("sidebarItemOverlay");
    t.style.display = "none";
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    //if headers changed, load/unload value of the column
    if (changes['show']) {

      var t = <HTMLInputElement>document.getElementById("sidebarItemOverlay");

      if (this.show) {
        t.style.display = "block";

        setTimeout(() => {
          document.getElementById("sidebarItemContainer")?.classList.add("show-sidebar");
          document.getElementById("sidebarItemContainer")?.classList.remove("hide-sidebar");
        });

      }
      else if (this.show === false)
        this.closeSidebar();
    }

  }

  closeSidebar() {
    var t = <HTMLInputElement>document.getElementById("sidebarItemOverlay");
    document.getElementById("sidebarItemContainer")?.classList.remove("show-sidebar")
    document.getElementById("sidebarItemContainer")?.classList.add("hide-sidebar")

    setTimeout(() => {
      this.show = false;
      t.style.display = "none";
      document.getElementById("sidebarItemContainer")?.classList.remove("show-sidebar")
      document.getElementById("sidebarItemContainer")?.classList.remove("hide-sidebar");

    }, 500);
  }
}
